module.exports = "/images/vendor/flag-icon-css/flags/4x3/nz.svg?3241e92770d44bbe8518b3ed7cabab9a";